import { Tooltip } from '@mui/material';
import { HeaderCellProps } from '../../types';

const IntegrationServerToIntegrationHeaderCell = ({
  _customRowProps: { integration },
}: HeaderCellProps) => {
  return (
    <Tooltip title={'Number of entities that needs to be created/updated on Integration'}>
      <div>Integration Server To {integration.label}</div>
    </Tooltip>
  );
};

export default IntegrationServerToIntegrationHeaderCell;
